import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { ContentService } from '../../spartacus/services/content.service';
import { Observable, take } from 'rxjs';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'app-real-world-comp',
    templateUrl: './real-world-comp.component.html',
    styleUrls: ['./real-world-comp.component.scss'],
    standalone: false
})
export class RealWorldCompComponent implements OnInit {
  firstheadline: Observable<any> = this.bannerComponent.data$;
  mergedObject1: any = [];
  userLoggedIn: boolean = false;
  selectedTile: number | null = 1; // Default to the first tile
  activePanel: number = 1;
  cardsList: any[]= [];
  activeIndex = 0;
  years: string[] = ['2017-2018', '2018-2019', '2019-2020'];
  isOpen1 = false;
  isOpen2 = false;
  isOpen3 = false;

  constructor(
    private accessService: ContentService,
    public bannerComponent: CmsComponentData<CmsBannerComponent>,
    protected config: OccConfig,
    private cd: ChangeDetectorRef,
    private userInfoService: UserInfoService,
    public contentService: ContentService,
    private viewportScroller: ViewportScroller,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.firstheadline.pipe(take(1)).subscribe(res => {
      this.clinicaltabs(res);
    });
    this.userInfoService.userLoggedIn$.subscribe(res => {
      this.userLoggedIn = res;
    });
    this.updateContentForTile(this.selectedTile!); // Initial content update
    this.firstheadline.subscribe(res => {
      this.tabdata(res);
    });
  }

  clinicaltabs(res: any) {
    const tilesList = res.realWorldList.split(" ");
    this.accessService.opeffeaturedResources(tilesList).subscribe((res: any) => {
      if (Array.isArray(res.component)) {
        this.mergedObject1 = res.component;
      } else if (res.component) {
        this.mergedObject1 = [res.component];
      } else {
        this.mergedObject1 = [];
      }
      this.cd.detectChanges();
    });
  }

  toggleSection(sectionNumber: number) {
    if (sectionNumber === 1) {
      this.isOpen1 = !this.isOpen1;
    } else if (sectionNumber === 2) {
      this.isOpen2 = !this.isOpen2;
    } else if (sectionNumber === 3) {
      this.isOpen3 = !this.isOpen3;
    }
  }

  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.desktop.url;
  }

  gettabsImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.desktop.url;
  }

  gettabsMobileImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.tablet.url;
  }

  selectTile(tile: number) {
    if (tile >= 1 && tile <= this.years.length) {
      this.selectedTile = tile;
      this.updateContentForTile(tile);
    }
  }

  updateContentForTile(tile: number): void {
    if (this.mergedObject1 && this.mergedObject1.length > tile - 1) {
      const selectedContent = this.mergedObject1[tile - 1];
      this.cd.detectChanges();
    } else {
      console.warn(`Content for tile ${tile} not found.`);
    }
  }

  setActivePanel(panel: number) {
    this.activePanel = panel;
    this.updateContentForTile(panel);
  }
  tabdata(res: any) {
    const tilesList = res?.realWorldList?.split(" ");
    if (tilesList) {
      this.contentService.opeffeaturedResources(tilesList).subscribe((res: any) => {
        this.cardsList = res.component;
        this.cd.detectChanges();
      });
    }
  }
  setActive(i: number) {
    this.activeIndex = i;
  }
    setActiveMobile(i: number) {
    const headings = document.querySelectorAll<HTMLElement>('.mobile_tab_heading.tab_Heading');
    const target = headings?.[i];
    // Fallback: if not found, just do a simple restore
    if (!target) {
      const [x, y] = this.viewportScroller.getScrollPosition();
      this.activeIndex = i;
      this.ngZone.onStable.pipe(take(1)).subscribe(() => {
        this.viewportScroller.scrollToPosition([x, y]);
      });
      return;
    }
    // Measure the heading's position before the DOM update
    const before = target.getBoundingClientRect().top;
    // Toggle the active tab
    this.activeIndex = i;
    // After Angular stabilizes, measure again and scroll by the difference
    this.ngZone.onStable.pipe(take(1)).subscribe(() => {
      const after = target.getBoundingClientRect().top;
      const delta = after - before;
      // Scroll the page by the delta so the heading stays fixed in the viewport
      if (delta !== 0) {
        // Use window.scrollBy for a precise relative scroll (instant, no smooth)
        window.scrollBy({ top: delta, left: 0, behavior: 'auto' });
      }
    });
  }
}
